
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gENQ6auGrUb1mv3_45YSmjvGQpv9hp2pfieNYiDU2uy4KsMeta } from "/codebuild/output/src1082200987/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexSQcx9R1_45nVlBPIfd_45EigX6NRlUYDrBTi04RmwtoGJCkMeta } from "/codebuild/output/src1082200987/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchqT874ws15EfXYhO_45_459QdeSRPfOBtC_45ykrJ3Yq0iJnd0Meta } from "/codebuild/output/src1082200987/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexLCYJ5NBcudajCPdMIw2F1Yk95fuL1l_45s7_45yCUA190_MMeta } from "/codebuild/output/src1082200987/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93__45Y82TbSrlS0Z84Aa_L8gMkAN_NgpuCjB9rG0TDlsPgMeta } from "/codebuild/output/src1082200987/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexZxKvvtHW2yRhBcdUvG2C87oX6_hTLlHTWUMdrajHmnEMeta } from "/codebuild/output/src1082200987/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_933ud_45c0B242VS9od0vc_45eMISL3pk3NA2UfGKwCZEvoWAMeta } from "/codebuild/output/src1082200987/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexw2dImT4VhhunaGd2zmyH3FySjBU8zQRTA8kkH_45LBjakMeta } from "/codebuild/output/src1082200987/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93hNFDAoV1kKlq1ucS_45AsswVjjN6DKhQkTR2IirdE38r4Meta } from "/codebuild/output/src1082200987/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexXC7lV8r5sbHFFsFHFFVaZ5wfYgi3ObYVsAOjEo1_45A3QMeta } from "/codebuild/output/src1082200987/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexD1s1z4xruzcybYLtoa347MaQzrxCQ55vJlsdzTA243kMeta } from "/codebuild/output/src1082200987/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src1082200987/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src1082200987/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src1082200987/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src1082200987/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src1082200987/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexZxKvvtHW2yRhBcdUvG2C87oX6_hTLlHTWUMdrajHmnEMeta || {},
    component: () => import("/codebuild/output/src1082200987/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src1082200987/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexw2dImT4VhhunaGd2zmyH3FySjBU8zQRTA8kkH_45LBjakMeta || {},
    component: () => import("/codebuild/output/src1082200987/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src1082200987/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexXC7lV8r5sbHFFsFHFFVaZ5wfYgi3ObYVsAOjEo1_45A3QMeta || {},
    component: () => import("/codebuild/output/src1082200987/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexD1s1z4xruzcybYLtoa347MaQzrxCQ55vJlsdzTA243kMeta || {},
    component: () => import("/codebuild/output/src1082200987/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]